// extracted by mini-css-extract-plugin
export default {"address-form":"NewAddressForm_address-form__w8OKa","submit-btn":"NewAddressForm_submit-btn__Dm2Li"};